import { render } from "./QHLSExamCenterList.vue?vue&type=template&id=710fdce9&scoped=true"
import script from "./QHLSExamCenterList.vue?vue&type=script&lang=js"
export * from "./QHLSExamCenterList.vue?vue&type=script&lang=js"

import "./QHLSExamCenterList.vue?vue&type=style&index=0&id=710fdce9&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-710fdce9"]])

export default __exports__